<template>
  <v-data-table
    :headers="headers"
    :items="info"
    :loading="loading_state"
    :rows-per-page-items="rowsPerPageItems"
    rows-per-page-text="每頁顯示幾筆"
    no-data-text="無資料"
  >
    <template slot="items" slot-scope="props">
      <td style="padding: 0px 5px;">{{ props.item.CourseNo }}</td>
      <td style="padding: 0px 5px;">{{ props.item.CourseName }}</td>
      <td style="padding: 0px 5px;">{{ props.item.CourseTeacher }}</td>
      <td style="padding: 0px 5px; word-break: break-all;">
        {{ props.item.Node }}
      </td>
      <td style="padding: 0px 5px;">{{ props.item.ClassRoomNo }}</td>
      <td style="padding: 0px 5px;">
        <v-btn
          flat
          icon
          v-on:click="showDeital(props.item.CourseNo,props.item.Semester)"
          v-if="props.item.CourseNo != ''"
        >
          <v-icon>more_horiz</v-icon>
        </v-btn>
      </td>
      <td style="padding: 0px 5px;" v-if="isLogin">
        <v-btn
          flat
          icon
          :disabled="props.item.disable"
          v-on:click="addSelectCourse(props.item)"
          v-if="props.item.CourseNo != '' && canSelectCourse"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data: () => ({
    headers: [
      { text: "課程代碼", width: "7%", align: "center", sortable: false },
      { text: "課程名稱", width: "10%", align: "center", sortable: false },
      { text: "授課教師", width: "7%", align: "center", sortable: false },
      { text: "上課星期節次", width: "7%", align: "center", sortable: false },
      { text: "教室", width: "7%", align: "center", sortable: false },
      { text: "大綱", width: "3%", align: "center", sortable: false },
    ],
    rowsPerPageItems: [50, 100, { text: "All", value: -1 }],
  }),
  computed: {
    canSelectCourse() {
      let selectSemester = this.$store.state.select_semester;
      return this.$store.state.semesters.find(
        (x) => x.Semester == selectSemester
      ).LoginEnable;
    },
    info() {
      return this.$store.state.info;
    },
    course_classes() {
      return this.$store.state.course_classes;
    },
    show_course_classes() {
      return this.$store.state.show_course_classes;
    },
    loading_state() {
      return this.$store.state.loading_state;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  watch: {
    isLogin(value) {
      if (value) {
        this.headers.push({
          text: "選取",
          width: "3%",
          align: "center",
          sortable: false,
        });
      } else {
        this.headers.pop();
      }
    },
  },
  methods: {
    showDeital: function(course_no) {
      this.$store.dispatch("queryDetial", {courseNo:course_no, Semester:""});
    },
    addSelectCourse: function(select_course) {
      // this.$store.commit("setShowMenu", true);
      this.$store.dispatch("pushSelectCourse", select_course);
    },
    getCourseClasses: function(select_course) {
      this.$store.dispatch("getCourseClasses", select_course);
    },
  },
  mounted() {
    if (this.$store.state.isLogin) {
      this.headers.push({
        text: "選取",
        width: "3%",
        align: "center",
        sortable: false,
      });
    }
  },
};
</script>
